import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from "@mui/material";
import useHeaders from '../../helpers/useHeaders';
import useEncryption from '../../services/useEncryption';
import { doctorDetailsApi } from '../../api/adminApi/adminApi';

function DoctorDetails() {
    const { id } = useParams();
    const [doctor, setDoctor] = useState(null);
    const [loading, setLoading] = useState(true);
    const { decryptData } = useEncryption();
    const headers = useHeaders();

    useEffect(() => {
        const fetchDoctor = async () => {
          try {
            const response = await doctorDetailsApi(id,headers); 
            setDoctor(decryptData(response.data.data));
            setLoading(false);
          } catch (error) {
            console.error('Error fetching doctor:', error);
          }
        };
    
        fetchDoctor();
      }, [id]);
    
      if (loading) {
        return <Typography>Loading...</Typography>;
      }
    
      if (!doctor) {
        return <Typography>Doctor not found</Typography>;
      }

    return ( 
        <Box>
            <Typography variant="h5">{`${doctor.firstName} ${doctor.lastName}`}</Typography>
            <Typography>Email: {doctor.email}</Typography>
            <Typography>Zipcode: {doctor.zipCode}</Typography>
        
      </Box>
     );
}

export default DoctorDetails;